import React from "react";

export default function LogoHorizontal(props) {
    return (
        <img width={props.width || "100%"} src="/img/logo-horizontal.svg" alt=""/>
    )
}
